export function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cookie/es6/utils.js
// module id = 775
// module chunks = 0